import axios from "./api";

const KassaKirimService = {

    /**
     * data should look like this
     * {
     *   "kassa_id": 1,
     *   "transport_id": 2,
     *   "summa": 15000,
     *   "izoh": "To'lov uchun kirim"
     * }
     * @param data
     * @returns {Promise<any>}
     */
    async createKassaKirim(data) {
        try {
            const response = await axios.post('/kassa_kirim', data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },
    async updateKassaKirim(data, id) {
        try {
            const response = await axios.put('/kassa_kirim/' + id, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },
    async deleteKassaKirim(id) {
        try {
            const response = await axios.delete('/kassa_kirim/' + id);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },

}

export default KassaKirimService;